<template>
  <div :is="tag">
    <span class="stylist-image--wrapper position-relative">
      <div class="box" :class="{ 'default-appointment-box': type == 'appointment' }">
        <img
          class="stylist-image"
          :class="{ 'stylist-image--disabled': disabled, 'default-stylist-image': !stylist.image && type == 'salon' }"
          :width="stylist.image || type == 'appointment' ? '120px' : '80px'"
          :height="stylist.image || type == 'appointment' ? '120px' : '80px'"
          :src="stylist.image ? stylist.image : type == 'salon' ? '/icons/profile_icon.svg' : '/icons/account-circle.svg'"
        />
      </div>
      <div class="position-relative">
        <img src="@/assets/star-gradient.png" class="star-icon" />
        <span class="white--text inset-all d-flex justify-center align-center text-subtitle-1 font-weight-medium no-select">
          {{ stylist.rate_number }}
        </span>
      </div>
    </span>
    <p class="secondary--text text-center text-subtitle-2 break-word mb-4 mt-6">
      {{ stylist.name }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
    stylist: { type: Object, required: true },
    tag: { type: String, default: 'div' },
    type: { type: String, required: true } // appointment or salon
  }
}
</script>

<style lang="scss" scoped>
.stylist-image--wrapper {
  .stylist-image {
    object-fit: cover;
    border-radius: 99vw;
    transition: filter 100ms ease-in;
  }

  .default-stylist-image {
    display: block;
    object-fit: contain;
    margin-left: auto;
    margin-right: auto;
    border-radius: 0;
    padding-top: 30px;
  }

  .star-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, calc(-50% - 3px));
    max-height: unset;
  }
}

.stylist-image--wrapper .stylist-image--disabled {
  filter: opacity(50%);
}

.stylist-image--wrapper:not(.stylist-image--disabled) {
  filter: opacity(100%);
}
.box {
  width: 100px;
  height: 100px;
  border-radius: 99vw;
  border: 1px solid #808080;
  @media only screen and (min-width: 1000px) {
    width: 120px;
    height: 120px;
  }
}
.default-appointment-box {
  border: 0;
}
</style>
